import { useState, useEffect, useContext } from "react";
import { useGetScheduleDelivery } from "../../../../../../../../../hooks/api/queries";
import { useParams, useSearchParams } from "react-router-dom";
import { useUpdateScheduleDeliveryDataMutation } from "../../../../../../../../../hooks/api/mutations/useInventory";
import { ToastContext } from "../../../../../../../../../hooks/context";
import { cleanObject } from "../../../../../../../../../helpers";

const useScheduleDelivery = ({ closeModal = () => {} }) => {
  const { menuId } = useParams();
  const [searchParams] = useSearchParams();
  const menu_id = searchParams.get("menu_id");
  const [changedData, setChangedData] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const [selected, setSelected] = useState({});
  const triggerToast = useContext(ToastContext);
  const updateScheduleDelivery = useUpdateScheduleDeliveryDataMutation();

  const {
    data: scheldule,
    isLoading: isLoadingScheduleDelivery,
    refetch: handleFetch,
  } = useGetScheduleDelivery({ storefrontId: menuId ? menuId : menu_id });

  const updateScheduleField = (id, updates) => {
    setChangedData((prev) => {
      const prevRow = prev[id] || { id };
      return {
        ...prev,
        [id]: { ...prevRow, ...updates },
      };
    });
  };

  const handleUpdateScheduleDelivery = () => {
    if (changedData.length === 0) {
      triggerToast("No New Update For Schedule Delivery", "warning");
      return;
    }

    updateScheduleDelivery.mutate(
      cleanObject({
        storefrontId: menuId || menu_id,
        data: Object.values(changedData),
      }),
      {
        onSuccess: () => {
          handleFetch();
          setChangedData([]);
          triggerToast("Schedule Delivery Updated", "success");
          closeModal();
        },
      },
    );
  };

  const allSelected =
    scheduleData.length > 0 && scheduleData.every((item) => selected[item.id]);

  const someSelected =
    scheduleData.length > 0 &&
    scheduleData.some((item) => selected[item.id]) &&
    !allSelected;

  const toggleItem = (id, value) => {
    setSelected((prev) => {
      const updated = { ...prev, [id]: value };

      setScheduleData((prevData) =>
        prevData.map((item) =>
          item.id === id ? { ...item, is_active: value } : item,
        ),
      );

      updateScheduleField(id, { is_active: value });

      return updated;
    });
  };

  const toggleAll = () => {
    if (allSelected) {
      const newSelection = {};
      const newData = scheduleData.map((item) => ({
        ...item,
        is_active: false,
      }));
      setSelected(newSelection);
      setScheduleData(newData);

      setChangedData(
        newData.map((item) => ({ id: item.id, is_active: false })),
      );
    } else {
      const newSelection = {};
      const newData = scheduleData.map((item) => {
        newSelection[item.id] = true;
        return { ...item, is_active: true };
      });
      setSelected(newSelection);
      setScheduleData(newData);

      setChangedData(newData.map((item) => ({ id: item.id, is_active: true })));
    }
  };

  useEffect(() => {
    if (Array.isArray(scheldule)) {
      setScheduleData(scheldule);
      const initSelected = {};
      scheldule.forEach((item) => {
        initSelected[item.id] = !!item.is_active;
      });
      setSelected(initSelected);
    }
  }, [scheldule]);

  return {
    changedData,
    scheldule,
    scheduleData,
    setScheduleData,
    toggleItem,
    toggleAll,
    someSelected,
    allSelected,
    selected,
    isLoadingScheduleDelivery,
    handleFetch,
    handleUpdateScheduleDelivery,
    updateScheduleDelivery,
    updateScheduleField,
  };
};

export default useScheduleDelivery;
